import { render, staticRenderFns } from "./Indexes.vue?vue&type=template&id=65227449&"
import script from "./Indexes.vue?vue&type=script&lang=js&"
export * from "./Indexes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports